import {
	Box,
	SimpleGrid,
	Icon,
	Text,
	useColorModeValue,
	Stack,
	Flex,
	Heading,
} from "@chakra-ui/react";

import { ReactComponent as GitIcon } from "../../Images/VersionControl/git-icon.svg";
import { ReactComponent as GitHubIcon } from "../../Images/VersionControl/github-icon.svg";
const Feature = ({ title, text, icon }) => {
	return (
		<Stack
			align={"center"}
			px={8}
			py={4}
			boxShadow={"xl"}
			color={useColorModeValue("gray.600", "gray.600")}
			bgGradient="linear(to-b, gray.50, gray.200)"
			rounded={"lg"}
			transform="scale(1.0)"
			alt="some text"
			objectFit="contain"
			width="100%"
			transition="0.2s ease-in-out"
			_hover={{
				transform: "scale(1.1)",
			}}
		>
			<Flex
				w={16}
				align={"center"}
				justify={"center"}
				color={"white"}
				rounded={"full"}
				mb={1}
			>
				{icon}
			</Flex>
			<Text fontWeight={600} fontSize={20}>
				{title}
			</Text>
		</Stack>
	);
};

export default function VersionControl() {
	return (
		<Box p={6} align={"center"}>
			<Heading
				fontSize={"2xl"}
				fontFamily={"body"}
				fontWeight={500}
				align="center"
				p={4}
				color={useColorModeValue("gray.600", "gray.300")}
			>
				Version Control
			</Heading>
			<SimpleGrid columns={{ base: 1, sm: 2, md: 2, lg: 2 }} spacing={16}>
				<Feature icon={<Icon as={GitIcon} w={20} h={20} />} title={"Git"} />
				<Feature
					icon={<Icon as={GitHubIcon} w={20} h={20} />}
					title={"GitHub"}
				/>
			</SimpleGrid>
		</Box>
	);
}
